import { render, staticRenderFns } from "./file-manager.vue?vue&type=template&id=2f6023c6&scoped=true"
import script from "./file-manager.vue?vue&type=script&lang=js"
export * from "./file-manager.vue?vue&type=script&lang=js"
import style0 from "./file-manager.vue?vue&type=style&index=0&id=2f6023c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6023c6",
  null
  
)

export default component.exports